function init() {

    const grids = document.querySelectorAll('.show-more-container');

    grids.forEach(grid => {
        const button = grid.querySelector('.show-more-button');
        if (!button) return;

        // Read group size from data attribute, fallback to 4
        const groupSizeAttr = grid.getAttribute('data-page-size');
        const groupSize = parseInt(groupSizeAttr, 10);
        const itemsToShowPerClick = isNaN(groupSize) || groupSize <= 0 ? 4 : groupSize;

        // Initial check: if no hidden items, remove the button right away
        const initialHiddenItems = grid.querySelectorAll('.show-more-item--hide');
        if (initialHiddenItems.length === 0) {
            button.remove();
            return;
        }

        //remove the u-hidden attribute on the button as we will need it
        //optional for a button to have one
        button.classList.remove('u-hidden');

        button.addEventListener('click', () => {
            const hiddenItems = grid.querySelectorAll('.show-more-item--hide');
            for (let i = 0; i < itemsToShowPerClick && i < hiddenItems.length; i++) {
                hiddenItems[i].classList.remove('show-more-item--hide');
            }

            // Remove button if there are no more hidden items
            const remainingHiddenItems = grid.querySelectorAll('.show-more-item--hide');
            if (remainingHiddenItems.length === 0) {
                button.remove();
            }
        });
    });


}

export { init }